package io.horion.cv.api.datasource.common

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Generate(
    @SerialName("_id")
    val id: String = "",
    val uuid: String = "",
    val uuidDocument: String = "",
    val ownerUuid: String = "",
    val fileUuid: String? = null,
    val path: String = "",
    val thumbnailPath: String = "",
    val url: String = "",
    val thumbnailUrl: String = "",
    val name: String? = null,
    val model: String? = null,
    val date: String = ""
)
